export default "__VITE_ASSET__CNY7Vndx__"